import ModalApproveDecline from './ModalApproveDecline';

export default ModalApproveDecline;
